const createModalWindow = () => {
  const container = document.body.appendChild(document.createElement('div'));
  const header = container.appendChild(document.createElement('h5'));
  const paragraph = container.appendChild(document.createElement('p'));
  const closeButton = container.appendChild(document.createElement('button'));
  container.id = 'test-notification-modal-window';
  header.className = 'modal-title';
  closeButton.className = 'close';
  closeButton.textContent = '×';

  return {
    container,
    header,
    paragraph,
    closeButton,
  };
};

let modalWindow = null;

const hideModalWindow = () => {
  if (modalWindow) {
    modalWindow.container.style.display = 'none';
  }
};

const showModalWindow = (title, message) => {
  if (!modalWindow) {
    modalWindow = createModalWindow();
    modalWindow.closeButton.addEventListener('click', hideModalWindow);
  }
  modalWindow.header.textContent = title;
  modalWindow.paragraph.textContent = message;
  modalWindow.container.style.display = 'block';
};

export const run = (scenarioName, configuration) => {
  if (
    configuration &&
    typeof configuration.title === 'string' &&
    typeof configuration.message === 'string'
  ) {
    showModalWindow(configuration.title, configuration.message);
  } else {
    showModalWindow('Внимание', `Сценарий ${scenarioName} выполнен`);
  }
  
  return Promise.resolve('OK');
};
